import {Customer,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from "@flexinet/ui-components";

import {useAllowedItems} from "../../../hooks/useAllowedProperties.ts";


export const BillingInfoPropertyCard = ({record: _record}: { record: Customer }) => {

    const properties = [
        {
            label: 'Billing Information',
            value: 'Managed through Provider Mappings',
            span: 12,
        }] as PlatformPropertyCardProperty[];


    const {filterAllowed} = useAllowedItems()

    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];


    return (
        <PlatformPropertyCard properties={allowedProperties}/>
    );


};
